import {useDownBreakpoint} from "@hooks";
import {CalendarToday} from "@mui/icons-material";
import {Box, Button, IconButton, Typography} from "@mui/material";
import dayjs from "dayjs";

const Today = ({
  disabled = false,
  onClick,
}: {
  disabled?: boolean;
  onClick: () => void;
}) => {
  const today = new Date().getDate();
  const isDownSm = useDownBreakpoint("sm");

  if (isDownSm) {
    return (
      <Box position={"relative"}>
        <Typography
          sx={{position: "absolute", left: 0, right: 0, top: 14}}
          variant="caption"
          color={disabled ? "text.secondary" : "text.primary"}
          textAlign={"center"}
          fontWeight={"bold"}>
          {today}
        </Typography>
        <IconButton onClick={onClick} disabled={disabled}>
          <CalendarToday fontSize="inherit" />
        </IconButton>
      </Box>
    );
  }

  return (
    <Button
      onClick={onClick}
      startIcon={<CalendarToday color={disabled ? "disabled" : "action"} />}
      variant="outlined"
      disabled={disabled}>
      {dayjs(new Date()).format("D MMMM")}
    </Button>
  );
};

export {Today};
